<template>
  <v-dialog
    v-model="isOpened"
    persistent
    scrollable
    width="600px"
  >
    <user-email-dialog
      v-model="isUserDialogOpened"
      :maker="maker"
      @save="userAdded"
      v-if="maker"
    />
    <v-card v-if="maker">
      <v-card-title>
        Inviter des utilisateurs
      </v-card-title>
      <v-card-subtitle>
        {{ maker.name }}
      </v-card-subtitle>
      <v-divider />
      <v-card-text class="pa-3 mb-2">
        <v-row no-gutters justify="center" align="center" class="pa-2 mt-2 text--secondary" style="min-height: 50px;" v-if="!users.length">
          Aucun utilisateur
        </v-row>
        <v-row class="px-4 py-1" justify="center" align="center">
          <v-col cols="12" class="py-2" v-for="user in users" :key="user.id">
            <n-card depressed class="px-3 py-1 font-weight-medium ellipsis" style="background: #EEE; cursor: default;">
              {{ user.email }}
            </n-card>
          </v-col>
        </v-row>
        <v-row no-gutters justify="center" align="center" class="pt-2">
          <v-btn text color="primary" class="mx-2" @click="isUserDialogOpened = true">
            <v-icon left>add</v-icon>
            Nouvel utilisateur
          </v-btn>
        </v-row>
      </v-card-text>
      <v-divider />
      <v-card-actions class="py-3 px-6">
        <v-btn text @click="ended">Passer cette étape</v-btn>
        <v-spacer></v-spacer>
        <v-btn
          color="primary darken-1"
          :disabled="users.length < 1"
          @click="ended"
        >
          Étape suivante
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import UserEmailDialog from '@/components/Users/UserEmailDialog.vue';

export default {
  props: {
    value: Boolean,
    maker: Object,
  },
  data: () => ({
    users: [],
    isUserDialogOpened: false,
  }),
  computed: {
    isOpened: {
      get() { return this.value; },
      set(value) { this.$emit(`input`, value); },
    },
  },
  methods: {
    initLocalState() {
      this.users = [];
    },
    ended() {
      this.isOpened = false;
      this.$emit(`ended`);
    },
    userAdded(user) {
      this.users.push(user);
    },
  },
  watch: {
    isOpened(isOpened) {
      if (isOpened) {
        this.initLocalState();
      }
    },
  },
  components: {
    UserEmailDialog,
  },
};
</script>
